import { render, staticRenderFns } from "./HrTrainSatisfyDetail.vue?vue&type=template&id=be5c442a&scoped=true&"
import script from "./HrTrainSatisfyDetail.vue?vue&type=script&lang=js&"
export * from "./HrTrainSatisfyDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrTrainSatisfyDetail.vue?vue&type=style&index=0&id=be5c442a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5c442a",
  null
  
)

export default component.exports